export const messages = {
  en: {
    adminComplaint: {
      search: {
        title: 'Search Conditions',
        roomName: 'Room',
        roomNamePlaceholder: 'Building-Unit-Room e.g. 1-1-1',
        complaintName: 'Contact',
        complaintNamePlaceholder: 'Please enter contact name',
        tel: 'Contact Tel',
        telPlaceholder: 'Please enter contact tel',
        complaintId: 'Complaint ID',
        complaintIdPlaceholder: 'Please enter complaint ID',
        startTime: 'Start Time',
        startTimePlaceholder: 'Please select start time',
        endTime: 'End Time',
        endTimePlaceholder: 'Please select end time'
      },
      list: {
        title: 'Complaint Suggestions'
      },
      table: {
        complaintId: 'Order ID',
        type: 'Type',
        room: 'Room',
        contact: 'Contact',
        contactTel: 'Contact Tel',
        status: 'Status',
        handler: 'Handler',
        createTime: 'Create Time',
        content: 'Content'
      },
      fetchError: 'Failed to fetch complaint list'
    }
  },
  zh: {
    adminComplaint: {
      search: {
        title: '查询条件',
        roomName: '房屋',
        roomNamePlaceholder: '楼栋-单元-房屋 如1-1-1',
        complaintName: '联系人',
        complaintNamePlaceholder: '请输入联系人',
        tel: '联系电话',
        telPlaceholder: '请输入联系电话',
        complaintId: '工单编号',
        complaintIdPlaceholder: '请输入工单编号',
        startTime: '开始时间',
        startTimePlaceholder: '请选择开始时间',
        endTime: '结束时间',
        endTimePlaceholder: '请选择结束时间'
      },
      list: {
        title: '投诉建议'
      },
      table: {
        complaintId: '订单编号',
        type: '类型',
        room: '房屋',
        contact: '联系人',
        contactTel: '联系电话',
        status: '状态',
        handler: '处理人',
        createTime: '创建时间',
        content: '内容'
      },
fetchError: '获取投诉列表失败'
    }
  },
  'zh-TW': {
    adminComplaint: {
      search: {
        title: '查詢條件',
        roomName: '房屋',
        roomNamePlaceholder: '樓棟-單元-房屋 如1-1-1',
        complaintName: '聯繫人',
        complaintNamePlaceholder: '請輸入聯繫人',
        tel: '聯繫電話',
        telPlaceholder: '請輸入聯繫電話',
        complaintId: '工單編號',
        complaintIdPlaceholder: '請輸入工單編號',
        startTime: '開始時間',
        startTimePlaceholder: '請選擇開始時間',
        endTime: '結束時間',
        endTimePlaceholder: '請選擇結束時間'
      },
      list: {
        title: '投訴建議'
      },
      table: {
        complaintId: '訂單編號',
        type: '類型',
        room: '房屋',
        contact: '聯繫人',
        contactTel: '聯繫電話',
        status: '狀態',
        handler: '處理人',
        createTime: '創建時間',
        content: '內容'
      },
      fetchError: '獲取投訴列表失敗'
    }
  }
}